import { Field as BaseField, type FieldDescriptionProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { fieldDescriptionStyle } from './FieldDescription.css';

type Props = FieldDescriptionProps;

export const FieldDescription = ({ ...delegated }: Props) => {
  return <BaseField.Description {...delegated} className={clsxs(fieldDescriptionStyle, delegated.className)} />;
};
